export default {
  grey_darkest: '#031b4e',
  grey_dark: '#5b6987',
  grey: '#8390af',
  grey_light: '#e5e8ed',
  grey_lightest: '#f3f5f9',
  white: '#ffffff',
  purple_darkest: '#32087a',
  purple_dark: '#6414ee',
  purple: '#9c64ff',
  purple_light: '#d8c1ff',
  purple_lightest: '#eadeff',
  blue_darkest: '#002c9b',
  blue_dark: '#0069ff',
  blue: '#4994ff',
  blue_light: '#92bfff',
  blue_lightest: '#c8dfff',
  green_darkest: '#005955',
  green_dark: '#00a099',
  green: '#33cfc8',
  green_light: '#98dfdc',
  green_lightest: '#d4efee',
  red_darkest: '#820800',
  red_dark: '#ff3a2e',
  red: '#ff8c84',
  red_light: '#ffbcb7',
  red_lightest: '#ffe2e0',
  orange: '#ff9950',
  orange_light: '#ffcba6',
  orange_lightest: '#ffebdd',
  teal: '#7bdeff',
  background: '#fff',
  primary_bg: '#f5f9ff',
  secondary_bg: '#ecfbf4',
  danger_bg: '#fdf3f6',
  content_bg: '#f8fdff',
  primary: '#0069ff',
  primary_hover: '#005fe6',
  success: '#11a95e',
  success_hover: '#0f9251',
  secondary: '#00a099',
  secondary_hover: '#33cfc8',
  danger: '#d91d1d',
  danger_hover: '#c31a1a',
  heading_color: '#031b4e',
  backdrop: 'rgba(243, 245, 249, 0.9)',
  dark: '#000',
  grey9: '#eff2fb',
  grey8: '#e3e8f4',
  grey7: '#d6dcea',
  grey6: '#a9b3ca',
  grey5: '#8a96b5',
  grey4: '#4d5b7c',
  grey3: '#24335a',
  grey2: '#081b4b',
  grey1: '#000c2a',
  panel_background: '#fafafa',
  panel_background_hover: '#ededed',
  disabled_opacity: '0.5',
  banner_info: '#f7f6fe',
  banner_success: '#f4f9f6',
  banner_warning: '#fef8f4',
  banner_error: '#fef5f5',
  cli_background: '#141b2e',
  cli_highlight: '#2f3d5c',
  cli_accent_1: '#af86ff',
  cli_accent_2: '#ff863e',
  teams_1: '#2a82ff',
  teams_2: '#00c6ff',
  teams_3: '#01d0c0',
  teams_4: '#00d688',
  teams_5: '#80d34a',
  teams_6: '#d7e200',
  teams_7: '#ffc001',
  teams_8: '#e681ff',
  teams_9: '#ff4c6c',
  teams_10: '#b458fc',
  border_radius_large: '8px',
  border_radius_xlarge: '10px',
  font_size_medium: '18px',
  header_height: '65px',
};
